export const inputOptions = {
  inputInfo(inputOption) {
    switch (inputOption) {
      case 'servicePartnerProfile': {
        return {
          name: {
            id: 'authorName',
            label: 'Full name',
            placeholder: 'Full name',
          },
          position: {
            id: 'position',
            label: 'Job title',
            placeholder: 'Job title',
          },
          company: {
            id: 'companyName',
            label: 'Company name',
            placeholder: 'Company name',
          },
          quote: {
            id: 'testimonialText',
            label: 'Testimonial',
            placeholder: 'Add testimonial content here',
          },
        };
      }
      case 'agencyOPP': {
        return {
          name: {
            id: 'authorName',
            label: "Author's Name",
            placeholder: "Author's Name",
          },
          position: {
            id: 'position',
            label: 'Position',
            placeholder: 'Position',
          },
          company: {
            id: 'companyName',
            label: 'Company name',
            placeholder: 'Company Name',
          },
          quote: {
            id: 'testimonialText',
            label: 'Testimonial message',
            placeholder: 'Add testimonial content here',
          },
        };
      }
      default: {
        return {
          name: {
            id: 'fullName',
            label: "Author's name",
            placeholder: "Author's name",
          },
          position: {
            id: 'jobTitle',
            label: 'Position',
            placeholder: 'Position',
          },
          company: {
            id: 'companyName',
            label: 'Company name',
            placeholder: 'Company name',
          },
          quote: {
            id: 'quoteText',
            label: 'Testimonial message',
            placeholder: 'Add testimonial content here',
          },
        };
      }
    }
  },
  getTitleFormat(param1, param2, param3) {
    return `${param1}, ${param2} - ${param3}`;
  },
};
